/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SpaceSymlink({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#SpaceSymlink_svg__a)"><path d="M0 0h16v16H0z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M9.204 13.962a6.497 6.497 0 0 0 5.777-6.956A6.5 6.5 0 0 0 2 7.474M8.5 7.5h4M6.5 4.5h4M9.8 10.5h.7" /><path fill="currentColor" d="m4.5 9.861.035-.001H6.19L4.968 8.502A.6.6 0 1 1 5.86 7.7l2.121 2.359a.6.6 0 0 1-.007.81l-2 2.142a.6.6 0 1 1-.877-.819l1.057-1.132h-.883l-.036.001L4.1 11.1a2.4 2.4 0 0 0-2.4 2.4v1.46a.6.6 0 1 1-1.2 0V13.5a3.6 3.6 0 0 1 3.6-3.6z" /></g><defs><clipPath id="SpaceSymlink_svg__a"><path d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;